const SDK_VERSION = '7.90.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
